import { render, staticRenderFns } from "./Lottery.vue?vue&type=template&id=dcfc46fe&scoped=true&"
import script from "./Lottery.vue?vue&type=script&lang=js&"
export * from "./Lottery.vue?vue&type=script&lang=js&"
import style0 from "./Lottery.vue?vue&type=style&index=0&id=dcfc46fe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcfc46fe",
  null
  
)

export default component.exports